import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import "./style.scss";
import { useAuth } from "../../common/AuthContext";

const SponsorInvoice = ({
  invoiceData2,
  setInvoiceData2,
  handlePrevious,
  handleNext,
}) => {
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);

  const { myConferenceId: ctxConferenceId } = useAuth();

  const [sessionConferenceId, setSessionConferenceId] = useState(() =>
    sessionStorage.getItem("selectedConferenceId") || ""
  );

  const effectiveConferenceId =
    Number(sessionConferenceId) || Number(ctxConferenceId) || 62;

  const BaseUrl = process.env.REACT_APP_BASE_URL;
  const getAuthToken = () => localStorage.getItem("token");

  useEffect(() => {
    const savedConferenceId =
      sessionStorage.getItem("selectedConferenceId") || "";
    setSessionConferenceId(savedConferenceId);
  }, []);

  const getInvoice = useCallback(async () => {
    const token = getAuthToken();

    if (!token) {
      setInvoiceData2(null);
      setErrorMsg("Token missing. Please login again.");
      setLoading(false);
      return;
    }

    if (!effectiveConferenceId) {
      setInvoiceData2(null);
      setErrorMsg("Conference id missing.");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setErrorMsg("");

      const res = await axios.get(`${BaseUrl}/invoice/${effectiveConferenceId}`, {
        headers: { Authorization: `Bearer ${token}` },
        validateStatus: (status) =>
          (status >= 200 && status < 300) || status === 404,
      });

      if (res.status === 404) {
        setInvoiceData2(null);
        setErrorMsg("Invoice not found yet.");
        return;
      }

      setInvoiceData2(res?.data?.invoices?.[0] || null);
    } catch (error) {
      console.error("Error fetching invoice data:", error);
      setInvoiceData2(null);
      setErrorMsg(
        error?.response?.data?.message || "Error fetching invoice data."
      );
    } finally {
      setLoading(false);
    }
  }, [BaseUrl, effectiveConferenceId, setInvoiceData2]);

  useEffect(() => {
    getInvoice();
  }, [getInvoice]);

  useEffect(() => {
    if (!isInvoiceOpen) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") setIsInvoiceOpen(false);
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isInvoiceOpen]);

  const openInvoice = () => setIsInvoiceOpen(true);
  const closeInvoice = () => setIsInvoiceOpen(false);

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="invoiceContainerS">
      <h1 className="invoiceTitle">Invoice</h1>

     

      <div
        style={{
          display: "flex",
          gap: 12,
          marginBottom: 16,
          justifyContent: "space-around",
        }}
      >
        <button
          style={{ backgroundColor: "#9B1321" }}
          className="next-button"
          onClick={openInvoice}
          type="button"
        >
          View Invoice
        </button>

        <button
          style={{ backgroundColor: "#9B1321" }}
          className="next-button"
          onClick={handleNext}
          type="button"
        >
          Next
        </button>
      </div>

      {!invoiceData2 && errorMsg && (
        <p className="error-message" style={{ marginBottom: 16 }}>
          {errorMsg}
        </p>
      )}

      {isInvoiceOpen && (
        <div
          className="invoiceModalOverlay"
          onClick={closeInvoice}
          role="presentation"
        >
          <div
            className="invoiceModal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Invoice details"
          >
            <div className="invoiceModalHeader">
              <h2 style={{ margin: 0 }}>Invoice Details</h2>
              <button
                className="invoiceModalClose"
                onClick={closeInvoice}
                type="button"
              >
                ×
              </button>
            </div>

            <div className="invoiceModalBody noDownloadInvoice">
              {!invoiceData2 ? (
                <p className="error-message">
                  {errorMsg || "No invoice data available."}
                </p>
              ) : (
                <div className="invoiceDetails">
                  <>
                    <div className="section general-info">
                      <h2>General Information</h2>

                      <div className="row">
                        <span className="label">Conference ID:</span>
                        <span className="value">
                          {effectiveConferenceId || "N/A"}
                        </span>
                      </div>

                      <div className="row">
                        <span className="label">Exhibit Number:</span>
                        <span className="value">
                          {invoiceData2?.exhibit_number || "N/A"}
                        </span>
                      </div>

                      <div className="row">
                        <span className="label">User Name:</span>
                        <span className="value">
                          {invoiceData2?.user_name || "N/A"}
                        </span>
                      </div>

                      <div className="row">
                        <span className="label">Total Amount:</span>
                        <span className="value">
                          ${invoiceData2?.total_amount ?? 0}
                        </span>
                      </div>

                      <div className="row">
                        <span className="label">Created At:</span>
                        <span className="value">
                          {invoiceData2?.created_at
                            ? new Date(
                                invoiceData2.created_at
                              ).toLocaleDateString()
                            : "N/A"}
                        </span>
                      </div>
                    </div>

                    <div className="section sponsorship-details">
                      <h2>Conference Sponsorship Details</h2>
                      {(invoiceData2?.conference_sponsorship_details?.length || 0) >
                      0 ? (
                        invoiceData2.conference_sponsorship_details.map(
                          (item, index) => (
                            <div key={index} className="row">
                              <span className="label">{item?.item}:</span>
                              <span className="value">${item?.price ?? 0}</span>
                            </div>
                          )
                        )
                      ) : (
                        <p>No conference sponsorship details available.</p>
                      )}
                    </div>

                    <div className="section booth-details">
                      <h2>Booth Cost Details</h2>
                      {(invoiceData2?.booth_cost_details?.length || 0) > 0 ? (
                        invoiceData2.booth_cost_details.map((booth, index) => (
                          <div key={index} className="row">
                            <span className="label">Size:</span>
                            <span className="value">{booth?.size || "N/A"}</span>
                            <span className="label">Cost:</span>
                            <span className="value">${booth?.cost ?? 0}</span>
                          </div>
                        ))
                      ) : (
                        <p>No booth cost details available.</p>
                      )}
                    </div>

                    <div className="section sponsorship-options">
                      <h2>Sponsorship Option Details</h2>
                      {(invoiceData2?.sponsorship_option_details?.length || 0) >
                      0 ? (
                        invoiceData2.sponsorship_option_details.map(
                          (option, index) => (
                            <div key={index} className="row">
                              <span className="label">{option?.title}:</span>
                              <span className="value">
                                ${option?.price ?? 0}
                              </span>
                            </div>
                          )
                        )
                      ) : (
                        <p>No sponsorship options available.</p>
                      )}
                    </div>

                    <div className="section sponsorship-options">
                      {(invoiceData2?.square_meters || 0) > 0 && (
                        <div className="row">
                          <span className="label">Shell Scheme Price:</span>
                          <span className="value">
                            ${invoiceData2?.shell_scheme_price ?? "N/A"}
                          </span>
                        </div>
                      )}

                      <div className="row">
                        <span className="label">Square Meters:</span>
                        <span className="value">
                          {invoiceData2?.square_meters || 0}
                        </span>
                      </div>
                    </div>
                  </>
                </div>
              )}
            </div>

            <div className="invoiceModalFooter">
              <button
                style={{ backgroundColor: "#9B1321" }}
                className="next-button"
                onClick={closeInvoice}
                type="button"
              >
                Close
              </button>
              <button
                style={{ backgroundColor: "#9B1321" }}
                className="next-button"
                onClick={handleNext}
                type="button"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SponsorInvoice;